import { Icon } from '@recargas-dominicanas/core/components';
import { style } from './error-page.module.css';

export function ErrorPage() {
  return (
    <div className={style.container}>
      <div className={style.content}>
        <div className={style.textContainer}>
          <Icon icon="dangerous" className={style.errorIcon} />
          <h1 className={style.title}>Algo salió mal</h1>
          <p className={style.description}>Ha ocurrido un error inesperado. Por favor, intenta recargar la página.</p>
        </div>
        <div className={style.supportSection}>
          <div className={style.supportHeader}>
            <Icon icon="support_agent" className={style.supportIcon} />
            <p className={style.supportText}>Si el problema persiste, contáctanos:</p>
          </div>
          <div className={style.supportLinks}>
            <a href="https://wa.me/18492651443" target="_blank" rel="noreferrer" className={style.supportLink}>(849) 265-1443</a>
          </div>
        </div>
      </div>
    </div>
  );
}
